export const TOP_BAR_TUTORIAL_URL = `https://www.youtube.com/embed/videoseries?list=PLE77bs3x7JUlAo2nrSOj9cT57q759U2Xo`;
